import { Injector } from '@angular/core';

export abstract class UserSettingsEffectDependencies {
	abstract readonly injector: Injector;
}
